import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { CartProvider } from "@/context/CartContext";
import { useLenis } from "@/hooks/useLenis";
import { DigitalBackground } from "@/components/DigitalBackground";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Catalog } from "@/components/Catalog";
import { About } from "@/components/About";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";

function Page() {
  useLenis();
  return (
    <div className="App grain" data-testid="rojdijital-app">
      <DigitalBackground />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Catalog />
        <About />
      </main>
      <Footer />
      <CartDrawer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(14,14,17,0.9)",
            border: "1px solid rgba(0,242,254,0.35)",
            color: "#f4f2ec",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <Page />
      </CartProvider>
    </LanguageProvider>
  );
}
